import React from 'react'
import './LoginView.scss'
import PropTypes from 'prop-types'
import QRCode from 'qrcode.react'
class LoginView extends React.Component {
  static propTypes = {
    login: PropTypes.func,
    submitMFA: PropTypes.func,
    getUser: PropTypes.func,
    router: PropTypes.shape({})
  }

  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      MFACode: '',
      invalidMessage: null,
      OTPAuthURI: null,
      showMFAPrompt: false
    }
  }

  login = (e) => {
    const { email, password } = this.state
    const { login, router, getUser } = this.props
    e.preventDefault()
    return login(email, password)
    .then((response) => {
      if (response.data.otpauth_uri) {
        this.setState({
          OTPAuthURI: response.data.otpauth_uri,
          showMFAPrompt: true
        })
      } else if (response.data.requires_mfa) {
        this.setState({
          showMFAPrompt: true
        })
      } else {
        getUser()
        router.push('/')
      }
    })
    .catch((e) => {
      if (e.response.status === 429) {
        this.setState({
          invalidMessage: 'You have had more than 3 failed login attempts in the last 5 minutes. For security purposes, you have been locked out. Please wait 30 minutes and try again.'
        })
      } else {
        this.setState({
          invalidMessage: 'Incorrect email or password. Please try again.'
        })
      }
    })
  }

  submitMFA = (e) => {
    const { email, MFACode } = this.state
    const { submitMFA, router, getUser } = this.props
    e.preventDefault()
    return submitMFA(email, MFACode)
    .then((response) => {
      getUser()
      router.push('/')
    })
    .catch((e) => {
      if (e.response.status === 429) {
        this.setState({
          invalidMessage: 'You have had more than 3 failed login attempts in the last 5 minutes. For security purposes, you have been locked out. Please wait 30 minutes and try again.'
        })
      } else {
        this.setState({
          invalidMessage: 'Your MFA Code was not correct. Please check Google Authenticator and try the code again.'
        })
      }
    })
  }

  setEmail = (event) => {
    this.setState({
      email: event.target.value
    })
  }

  setPassword = (event) => {
    this.setState({
      password: event.target.value
    })
  }
  setMFACode = (event) => {
    this.setState({
      MFACode: event.target.value
    })
  }

  render () {
    const { email, password, invalidMessage, showMFAPrompt, OTPAuthURI, MFACode } = this.state
    return (
      <form>
        <p style={{color: 'red'}}>If you just signed in, try reloading the page.</p>
        {
          !showMFAPrompt ? (
            <div>
              <div className='form-group row'>
                <label htmlFor='inputEmail3' className='col-sm-2 col-form-label'>Username</label>
                <div className='col-sm-10'>
                  <input type='email' className='form-control' id='inputEmail3' placeholder='Username' value={email}
                    onChange={this.setEmail} />
                </div>
              </div>
              <div className='form-group row'>
                <label htmlFor='inputPassword3' className='col-sm-2 col-form-label'>Password</label>
                <div className='col-sm-10'>
                  <input type='password' className='form-control' id='inputPassword3' placeholder='Password'
                    value={password} onChange={this.setPassword} />
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-sm-10'>
                  <button onClick={this.login} className='btn btn-primary'>Sign in</button>
                </div>
              </div>
              <div>
                {
                  invalidMessage ? (
                    <div className='form-group row'>
                      <div className='col-sm-12'>
                        <div className='form-control-feedback invalid-login'>{ invalidMessage }</div>
                      </div>
                    </div>
                  ) : null
                }
              </div>
            </div>
        ) : (
          <div className='row'>
            <div className='offset-sm-3 col-sm-6'>
              <div>
                <div>
                  {OTPAuthURI
                    ? <QRCode value={OTPAuthURI} style={{ margin: 50 }} />
                    : null
                  }
                  <div style={{ marginTop: 20, marginBottom: 20 }}>
                    <h4>Instructions</h4>
                    <div style={{ marginTop: 20, textAlign: 'left' }}>
                      <div>1.
                        {OTPAuthURI
                          ? 'Download the Google Authenticator App on your phone and scan the above QR Code.'
                          : 'Open the Google Authenticator App.'
                        }
                      </div>
                      <div>2. Type the code provided by Google Authenticator into the box below and click Sign In.</div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className='form-group row'>
                    <div className='col-sm-12'>
                      <input type='text' className='form-control' id='mfaCode' placeholder='Code' value={MFACode}
                        onChange={this.setMFACode} />
                    </div>
                  </div>
                </div>
              </div>
              <div className='form-group row'>
                <div className='col-sm-12'>
                  <button className='btn btn-primary' onClick={this.submitMFA}>Sign In</button>
                </div>
              </div>
              <div>
                {
                  invalidMessage ? (
                    <div className='form-group row'>
                      <div className='col-sm-12'>
                        <div className='form-control-feedback invalid-login'>{ invalidMessage }</div>
                      </div>
                    </div>
                  ) : null
                }
              </div>
            </div>
          </div>
        ) }
      </form>
    )
  }
}

export default LoginView



// WEBPACK FOOTER //
// ./src/routes/Login/components/LoginView.jsx